/*
  Fizzy Moo store locator.
  Reads the stores from the JSON inside each [data-fm-stores] section,
  shows open or closed in Colorado time, draws a Leaflet map, and sorts
  the list by distance when a visitor taps "Find the nearest store".
*/
(function () {
  var TZ = 'America/Denver';
  var DAYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
  var DAY_LABELS = { sun: 'Sun', mon: 'Mon', tue: 'Tue', wed: 'Wed', thu: 'Thu', fri: 'Fri', sat: 'Sat' };

  function parseTime(text) {
    var m = String(text || '').trim().match(/^(\d{1,2})(?::(\d{2}))?\s*(AM|PM)$/i);
    if (!m) return null;
    var h = parseInt(m[1], 10) % 12;
    if (m[3].toUpperCase() === 'PM') h += 12;
    return h * 60 + (m[2] ? parseInt(m[2], 10) : 0);
  }

  function parseRange(text) {
    var parts = String(text || '').split(/\s*[-–—]\s*|\s+to\s+/i);
    if (parts.length !== 2) return null;
    var open = parseTime(parts[0]);
    var close = parseTime(parts[1]);
    if (open === null || close === null) return null;
    return { open: open, close: close, openText: parts[0].trim(), closeText: parts[1].trim() };
  }

  function nowInColorado() {
    var fmt = new Intl.DateTimeFormat('en-US', {
      timeZone: TZ,
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      hour12: false,
    });
    var parts = {};
    fmt.formatToParts(new Date()).forEach(function (p) {
      parts[p.type] = p.value;
    });
    var dayIndex = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(parts.weekday);
    var hour = parseInt(parts.hour, 10) % 24;
    return { dayIndex: dayIndex, minutes: hour * 60 + parseInt(parts.minute, 10) };
  }

  function openStatus(hours) {
    var now = nowInColorado();
    if (now.dayIndex < 0) return '';
    var today = parseRange(hours[DAYS[now.dayIndex]]);
    if (today && now.minutes >= today.open && now.minutes < today.close) {
      return { open: true, text: 'Open now, until ' + today.closeText };
    }
    if (today && now.minutes < today.open) {
      return { open: false, text: 'Closed now, opens today at ' + today.openText };
    }
    for (var i = 1; i <= 7; i++) {
      var key = DAYS[(now.dayIndex + i) % 7];
      var next = parseRange(hours[key]);
      if (next) {
        return { open: false, text: 'Closed now, opens ' + (i === 1 ? 'tomorrow' : DAY_LABELS[key]) + ' at ' + next.openText };
      }
    }
    return { open: false, text: 'Closed now' };
  }

  function milesBetween(lat1, lng1, lat2, lng2) {
    var toRad = function (d) {
      return (d * Math.PI) / 180;
    };
    var R = 3958.8;
    var dLat = toRad(lat2 - lat1);
    var dLng = toRad(lng2 - lng1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * R * Math.asin(Math.sqrt(a));
  }

  function init(section) {
    if (!section || section.dataset.fmReady === 'true') return;
    var dataEl = section.querySelector('[data-fm-stores-json]');
    if (!dataEl) return;
    var stores;
    try {
      stores = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    section.dataset.fmReady = 'true';

    var list = section.querySelector('[data-fm-list]');
    var items = Array.prototype.slice.call(section.querySelectorAll('[data-fm-store]'));
    var status = section.querySelector('[data-fm-status]');
    var nearestBtn = section.querySelector('[data-fm-nearest]');
    var mapEl = section.querySelector('[data-fm-map]');

    stores.forEach(function (s, i) {
      s.lat = parseFloat(s.lat);
      s.lng = parseFloat(s.lng);
      var item = items[i];
      if (!item) return;
      var st = openStatus(s.hours || {});
      var openEl = item.querySelector('[data-fm-open]');
      if (openEl && st) {
        openEl.textContent = st.text;
        openEl.classList.add(st.open ? 'is-open' : 'is-closed');
      }
    });

    var map = null;
    var markers = [];
    if (mapEl && window.L) {
      map = window.L.map(mapEl, { scrollWheelZoom: false });
      window.L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(map);
      var bounds = [];
      stores.forEach(function (s, i) {
        if (isNaN(s.lat) || isNaN(s.lng)) return;
        var marker = window.L.circleMarker([s.lat, s.lng], {
          radius: 9,
          color: '#121212',
          weight: 3,
          fillColor: '#FF8FB1',
          fillOpacity: 1,
        }).addTo(map);
        var popup = document.createElement('div');
        var strong = document.createElement('strong');
        strong.textContent = s.name;
        popup.appendChild(strong);
        popup.appendChild(document.createElement('br'));
        popup.appendChild(document.createTextNode(s.address));
        marker.bindPopup(popup);
        marker.on('click', function () {
          highlight(i, false);
        });
        markers[i] = marker;
        bounds.push([s.lat, s.lng]);
      });
      if (bounds.length) map.fitBounds(bounds, { padding: [30, 30], maxZoom: 13 });
    } else if (mapEl) {
      mapEl.hidden = true;
    }

    function highlight(index, pan) {
      items.forEach(function (item) {
        item.classList.toggle('is-active', Number(item.dataset.index) === index);
      });
      if (map && markers[index] && pan) {
        map.setView(markers[index].getLatLng(), 14);
        markers[index].openPopup();
      }
    }

    items.forEach(function (item) {
      item.addEventListener('click', function (event) {
        if (event.target.closest('a, summary')) return;
        highlight(Number(item.dataset.index), true);
      });
    });

    if (nearestBtn) {
      if (!('geolocation' in navigator)) {
        nearestBtn.hidden = true;
      } else {
        nearestBtn.addEventListener('click', function () {
          status.textContent = 'Finding stores near you…';
          navigator.geolocation.getCurrentPosition(
            function (pos) {
              var here = pos.coords;
              var ranked = stores
                .map(function (s, i) {
                  return { i: i, miles: milesBetween(here.latitude, here.longitude, s.lat, s.lng) };
                })
                .filter(function (r) {
                  return !isNaN(r.miles);
                })
                .sort(function (a, b) {
                  return a.miles - b.miles;
                });
              ranked.forEach(function (r) {
                var item = items[r.i];
                var d = item.querySelector('[data-fm-distance]');
                if (d) {
                  d.textContent = (r.miles < 10 ? r.miles.toFixed(1) : Math.round(r.miles)) + ' mi';
                  d.hidden = false;
                }
                list.appendChild(item);
              });
              if (ranked.length) {
                status.textContent = 'Closest first. ' + stores[ranked[0].i].name + ' is nearest.';
                highlight(ranked[0].i, true);
              }
            },
            function () {
              status.textContent = "We couldn't get your location. The list below still works.";
            },
            { enableHighAccuracy: false, timeout: 10000, maximumAge: 600000 }
          );
        });
      }
    }
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-fm-stores]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-fm-stores]');
    if (section) init(section);
  });
})();
